import Button from "../../button/Button";
import InputField from "../input-field/InputField";
import "./ApiConnectionModule.scss";

interface ApiConnectionsModuleProps {
  clientName: string;
  applicationId: string;
  weightronUid: string;
  weightronSecret: string;
  weightronApiKey: string;
  collectionId: string;
  endpointUrl?: string;
  connectionInProgress: boolean;
  submissionInProgress: boolean;
  isSuccess?: boolean;
  submitMsg?: string;

  invalidClientName?: string;
  invalidApplicationId?: string;
  invalidWeightronUid?: string;
  invalidWeightronSecret?: string;
  invalidWeightronApiKey?: string;
  invalidCollectionId?: string;
  invalidEndpointUrl?: string;

  setClientName: (name: string) => void;
  setApplicationId: (id: string) => void;
  setWeightronUid: (uid: string) => void;
  setWeightronSecret: (secret: string) => void;
  setWeightronApiKey: (key: string) => void;
  setCollectionId: (id: string) => void;
  setEndpointUrl?: (url: string) => void;
  onEvaluateConnection: () => void;
  onSave: () => void;
  resetInvalidMsg: () => void;

  darkMode: boolean;
  editMode?: boolean;
}

const ApiConnectionModule = (props: ApiConnectionsModuleProps) => {
  return (
    <>
      <div className="connection-form">
        <InputField
          label="Client Name *"
          value={props.clientName}
          type="text"
          disabled={props.editMode}
          invalidMsg={props.invalidClientName}
          onChange={(val) => {
            props.resetInvalidMsg();
            props.setClientName(val);
          }}
          darkMode={props.darkMode}
        />
        <InputField
          label="Application ID *"
          value={props.applicationId}
          type="text"
          disabled={props.editMode}
          invalidMsg={props.invalidApplicationId}
          onChange={(val) => {
            props.resetInvalidMsg();
            props.setApplicationId(val);
          }}
          darkMode={props.darkMode}
        />
        <InputField
          label="Weightron UID *"
          value={props.weightronUid}
          type="text"
          invalidMsg={props.invalidWeightronUid}
          onChange={(val) => {
            props.resetInvalidMsg();
            props.setWeightronUid(val);
          }}
          darkMode={props.darkMode}
        />
        <InputField
          label="Weightron Secret *"
          value={props.weightronSecret}
          type="password"
          invalidMsg={props.invalidWeightronSecret}
          onChange={(val) => {
            props.resetInvalidMsg();
            props.setWeightronSecret(val);
          }}
          darkMode={props.darkMode}
        />
        <InputField
          label="Weightron API Key *"
          value={props.weightronApiKey}
          type="text"
          invalidMsg={props.invalidWeightronApiKey}
          onChange={(val) => {
            props.resetInvalidMsg();
            props.setWeightronApiKey(val);
          }}
          darkMode={props.darkMode}
        />
        <InputField
          label="Collection ID *"
          value={props.collectionId}
          type="text"
          invalidMsg={props.invalidCollectionId}
          onChange={(val) => {
            props.resetInvalidMsg();
            props.setCollectionId(val);
          }}
          darkMode={props.darkMode}
        />
        {props.editMode && (
          <InputField
            label="Endpoint URL"
            value={props.endpointUrl ?? ""}
            type="text"
            invalidMsg={props.invalidEndpointUrl}
            onChange={(val) => {
              props.resetInvalidMsg();
              if (props.setEndpointUrl) props.setEndpointUrl(val);
            }}
            darkMode={props.darkMode}
          />
        )}
      </div>
      <div className="btn-wrapper">
        <div className={"info-box" + (props.darkMode ? " dark" : "")}>
          <p>* = Required</p>
        </div>
        <div className="buttons-panel">
          <Button
            title="Evaluate Connection"
            className="submit-button connect"
            onClick={props.onEvaluateConnection}
            loading={props.connectionInProgress}
          />
          <Button
            title="Save"
            className="submit-button save"
            onClick={props.onSave}
            loading={props.submissionInProgress}
          />
        </div>
      </div>
      {props.submitMsg && (
        <div className={props.isSuccess ? "success-msg" : "error-msg"}>
          <span>{props.submitMsg}</span>
        </div>
      )}
    </>
  );
};

export default ApiConnectionModule;
